import {Component, OnInit} from "@angular/core";
import {MessagesSettings} from "./components/messages.settings";
import {MessageCollection} from "../shared/api/messages/api.models";
import {ActivatedRoute, Router} from "@angular/router";
import {Api} from "../shared/api.service";

@Component({
    selector : 'edit-message',
    template: require('./edit.component.html'),
    styles: [require('./edit.component.scss')],
})

export class EditMessageComponent implements OnInit {

    protected settings          : MessagesSettings;
    protected messageCollection : MessageCollection;
    protected isLoading         : boolean  = true;

    constructor(private api: Api, private route: ActivatedRoute, private router: Router,) {}

    ngOnInit(): void {
        this.settings              = new MessagesSettings();
        this.settings.startScreen  = MessagesSettings.SCREEN_MESSAGE;

        const messageId              = this.route.snapshot.queryParams.messageId;

        this.api.messages().resource(messageId).subscribe(
            (messageCollection: MessageCollection) => {
                const tag = messageCollection.metadata.tags[0]
                this.messageCollection = messageCollection;
                this.settings.followUpAllowed = tag === MessageCollection.TAG_DEFAULT;
                this.settings.editing = true;
                this.isLoading = false;
            }
        )
    }

    done(): void {
        this.settings.editing = false;
        this.router.navigate(['messages/overview']);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/messages/edit.component.ts